<template>
  <v-dialog :value="dialog" max-width="600" @input="handler">
    <v-card>
      <!-- 搜索栏  -->
      <v-toolbar color="success">
        <v-toolbar-title class="white--text">
          <div style="padding-left: 20px">页面选择</div>
        </v-toolbar-title>
      </v-toolbar>

      <div class="max-vh-50 overflow-auto pa-5" style="width: 100%">
        <v-row dense>
          <v-col class="px-1" cols="12" v-show="loading"
            ><v-progress-linear
              :active="loading"
              :indeterminate="loading"
            ></v-progress-linear
          ></v-col>
          <v-col cols="12">
            <v-treeview
              v-if="dialogEdit"
              activatable
              :items="pageList"
              return-object
              transition
              open-on-click
              :load-children="loadChildren"
              :open.sync="open"
              @update:active="treeSelected"
            ></v-treeview>
          </v-col>
        </v-row>
      </div>
      <div class="py-4 px-4 text-right">
        <v-spacer></v-spacer>
        <v-btn color="success" dark @click.stop="submit" :disabled="!selected.length">确认</v-btn>
        <v-btn class="ml-2" color="gray" @click.stop="cancel">取消</v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from "vuex";
import { allInterfacePage } from "@/api/interface/interface_page";
const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
export default {
  components: {},
  props: {
    dialogEdit: {
      type: Boolean,
      default: false,
    },
    pageList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      list: [],
      open: [],
      selected: [],
      // 分页
      pagination: {
        page: 1,
        itemsPerPage: 4,
        total: 0,
      },
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["typeList"]),
    dialog: {
      get() {
        return this.dialogEdit;
      },
    },
  },
  watch: {
    dialogEdit: {
      handler(newVal, oldVal) {
        if (newVal) {
          // this.refreshTree();
          this.selected = []
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {},
  methods: {
    // 列表刷新
    refreshTree() {
      this.loading = true;
      this.list = []
      this.typeList.forEach((item) => {
        const tempList = item.interface?.map((ele) => {
          return {
            id: ele.id,
            name: item.name + "_" + ele.name,
            children: [],
          };
        });
        this.list = this.list.concat(tempList);
        this.loading = false;
      });
    },

    // 提交
    submit() {
      this.$emit("handleSubmit", this.selected);
    },
    // 返回
    cancel() {
      this.$emit("handleCancel");
    },
    handler(val) {
      this.$emit("update:dialogEdit", val);
    },
    async loadChildren(item) {
      await pause(100)
      return allInterfacePage({ parentId: item.id }).then((res) => {
        const rows = res.data.rows;
        rows.forEach((ele) => {
          let arr = {
            id: ele._id,
            name: ele.name,
            key: ele.key,
            pId: item.id,
          };
          item.children.push(arr);
        });
      });
    },

    /**
     * 数据结构选择
     */
    async treeSelected(array) {
      this.selected = array
    },
  },
};
</script>
<style lang="scss" scoped>
.img-card {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.img {
  width: 200px;
  height: 180px;
  margin: 0 !important;
}

.md-group {
  margin-bottom: 24px;
}

.md-button {
  border-radius: 0;
}

.md-tab {
  max-width: 600px;
  max-height: 400px;
  overflow: auto;
}

.v-List-actived {
  background: #ddd;
}

.v-application .indigo--text {
  background: #fff;
}

.disable-color {
  color: #ddd !important;

  i {
    color: #ddd !important;
  }
}
</style>